<template>
    <v-dialog v-model="dialog" max-width="600px">
        <template v-slot:activator="{ on }">
            <v-btn class="submit-button width-100p block" v-on="on">Создать выплату</v-btn>
        </template>
        <v-card>
            <v-card-title>
                <span class="headline">Выплатить вознаграждение</span>
            </v-card-title>
            <v-card-text>
                <v-form ref="payForm">
                    <v-container>
                        <v-layout row>
                            <v-flex xs12>
                                <span>Ваше вознаграждение: {{ this.balance + '\xa0₽'}}</span>
                            </v-flex>
                        </v-layout>
                        <v-layout v-if="canPayAgents" row wrap>
                            <v-flex xs12>
                                <v-checkbox
                                    v-model="self"
                                    label="Для себя"
                                    @change="selectedAgents = []"
                                />
                            </v-flex>
                            <v-flex xs12>
                                <v-autocomplete xs12
                                    v-model="selectedAgents"
                                    ref="filterAgent"
                                    label="Пользователь"
                                    :items="agents"
                                    :loading="isLoadingAgentsFilter"
                                    item-value="id"
                                    item-text="name"
                                    :rules="self ? [] : [rules.required, rules.requiredArray]"
                                    :disabled="self"
                                    placeholder="Введите ФИО или email"
                                    hide-no-data
                                    multiple
                                    chips
                                    deletable-chips
                                    :allow-overflow=false
                                    required
                                >
                                    <template v-slot:item="data">
                                        <template>
                                            <v-list-tile-title>{{data.item.name + ' ' + data.item.weekly_balance + ' ₽'}}</v-list-tile-title>
                                        </template>
                                    </template>
                                    <v-list-tile
                                        slot="prepend-item"
                                        ripple
                                        @click="toggleAgents"
                                    >
                                        <v-list-tile-action>
                                            <v-icon :color="selectedAgents.length > 0 ? '#00ba57' : ''">
                                                {{ selectAgentsIcon }}
                                            </v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-title>Выбрать все</v-list-tile-title>
                                    </v-list-tile>
                                    <v-list-tile
                                        slot="prepend-item"
                                        ripple
                                        @click="togglePhysicalAgents"
                                    >
                                        <v-list-tile-action>
                                            <v-icon :color="selectPhysicalAgentsIcon !== 'check_box_outline_blank' ? '#00ba57' : ''">
                                                {{ selectPhysicalAgentsIcon }}
                                            </v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-title>Выбрать всех физ.лиц</v-list-tile-title>
                                    </v-list-tile>
                                </v-autocomplete>
                            </v-flex>
                        </v-layout>
                        <v-layout v-if="canPayAgents" row wrap>
                            <v-flex xs12 py0>
                                <v-radio-group v-model="commissionType" row>
                                    <v-radio label="В рублях"
                                             value="absolute">
                                    </v-radio>
                                    <v-radio label="В процентах"
                                             value="percentage">
                                    </v-radio>
                                    <v-radio label="За период"
                                             value="periodic">
                                    </v-radio>
                                </v-radio-group>
                            </v-flex>
                            <v-flex v-if="commissionType === 'absolute'" xs12 py0>
                                <v-text-field
                                    label="Сумма, руб"
                                    v-model="sum"
                                    :rules="[rules.required, rules.digits, rules.minNum, rules.maxNum]"
                                    mask="######"
                                    required
                                />
                            </v-flex>
                            <v-flex v-if="commissionType === 'percentage'" xs12 py0>
                                <v-text-field
                                    label="Процент"
                                    v-model="percent"
                                    :rules="[rules.required, rules.digits, rules.minNum, rules.maxNumPercent]"
                                    mask="###"
                                    required
                                />
                            </v-flex>
                            <template v-if="commissionType === 'periodic'">
                                <v-flex xs12 sm6>
                                    <osago-date
                                        label="Период, от"
                                        v-model="dateFrom"
                                        :max="dateTo"
                                        :yearStarting="false"
                                        :isRequired="true"
                                    />
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <osago-date
                                        label="Период, до"
                                        v-model="dateTo"
                                        :min="dateFrom"
                                        :yearStarting="false"
                                        :isRequired="true"
                                    />
                                </v-flex>
                            </template>
                        </v-layout>
                        <v-layout v-else row wrap>
                            <v-flex xs12 py0>
                                <v-text-field
                                    label="Сумма, руб"
                                    v-model="sum"
                                    :rules="[rules.required, rules.digits, rules.minNum, rules.maxNum]"
                                    mask="######"
                                    required
                                />
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" flat
                       :disabled="loading"
                       @click="dialog = false">Закрыть</v-btn>
                <v-btn class="submit-button block"
                       :loading="loading"
                       @click="payCommission">Выплатить</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import _ from "lodash";

export default {
    props: {
        agents: {
            default: []
        },
        isLoadingAgentsFilter: {
            default: false
        },
        type: {
            default: null
        },
        balance: {
            default: '0'
        }
    },
    data: () => ({
        dialog: false,
        selectedAgents: [],
        commissionType: 'absolute', // absolute/percentage/periodic
        sum: null,
        percent: null,
        dateFrom:null,
        dateTo: null,
        self: false, // вывод комиссии себе
        loading: false,
        rules: {
            required: v => !!v || 'Обязательное поле',
            requiredArray: v => (!!v && v.length > 0) || 'Обязательное поле',
            digits: v => /^\d+$/.test(v) || 'Доступны только числа',
            maxNum: v => v <= 999999 || 'Значение не может быть больше 999999',
            maxNumPercent: v => v <= 100 || 'Значение не может быть больше 100',
            minNum: v => v > 0 || 'Значение не может быть меньше 1'
        }
    }),
    watch: {
        dialog(newValue, oldValue) {
            // при закрытии очистим список выбранных агентов
            if (!newValue) {
                this.clearForm();
            }
        }
    },
    computed: {
        physicalAgentsArray() {
            return this.agents.filter(a => a.user_type === Vue.GetpolisConstants.USER_TYPES.PHYSICAL).map(a => a.id).sort();
        },
        canPayAgents() {
            return this.type === Vue.GetpolisConstants.AGENT_TYPES.CURATOR ||
                this.type === Vue.GetpolisConstants.AGENT_TYPES.ADMIN;
        },
        selectedAllAgents() {
            return this.selectedAgents.length === this.agents.length;
        },
        selectedSomeAgents() {
            return this.selectedAgents.length > 0 && !this.selectedAllAgents;
        },
        selectAgentsIcon() {
            if (this.selectedAllAgents) return 'check_box';
            if (this.selectedSomeAgents) return 'indeterminate_check_box';
            return 'check_box_outline_blank';
        },
        selectedAllPhysicalAgents() {
            return _.isEqual(_.sortBy(this.selectedAgents), this.physicalAgentsArray);
        },
        selectedSomePhysicalAgents() {
            if (!this.selectedAllPhysicalAgents) {
                const len = this.selectedAgents.length;
                for (let i = 0; i < len; i++) {
                    if (this.physicalAgentsArray.indexOf(this.selectedAgents[i]) > -1) {
                        return true;
                    }
                }
                return this.selectedAgents.length > 0 && !this.selectedAllPhysicalAgents;
            }
            return false;
        },
        selectPhysicalAgentsIcon() {
            if (this.selectedAllPhysicalAgents) return 'check_box';
            if (this.selectedSomePhysicalAgents) return 'indeterminate_check_box';
            return 'check_box_outline_blank';
        },
    },
    created() {},
    methods: {
        clearForm() {
            this.selectedAgents = [];
            this.sum = null;
            this.percent = null;
            this.dateFrom = null;
            this.dateTo = null;
            this.self = false;
            this.$refs.payForm.resetValidation();
        },
        payCommission() {
            if (this.$refs.payForm.validate()) {
                const sum = parseInt(this.sum);
                if (this.self || this.type === Vue.GetpolisConstants.AGENT_TYPES.AGENT) {
                    if (sum > this.balance) {
                        PNotify.error('Недостаточно средств для вывода.');
                        return;
                    }
                } else {
                    let errors = [];
                    let found = false;
                    for (let i = 0; i < this.selectedAgents.length; i++) {
                        found = false;

                        for (let j = 0; j < this.agents.length; j++) {
                            found = this.agents[j].id === this.selectedAgents[i];
                            if (found) {
                                if (this.agents[j].weekly_balance < sum) {
                                    errors.push(this.agents[j].name);
                                }
                                break;
                            }
                        }
                    }
                    if (errors.length > 0) {
                        PNotify.error('Недостаточно средств для вывода: \n' + errors.join('\n'));
                        return;
                    }
                }
                this.submit();
            } else {
                this.$nextTick(function () {
                    PNotify.error('Проверьте правильность выделенных полей.');
                    this.goToFirstError();
                });
            }
        },
        submit() {
            this.loading = true;

            let data = null;
            if (this.commissionType === 'absolute') {
                data = {
                    'sum': this.sum
                };
            } else if (this.commissionType === 'percentage') {
                data = {
                    'percent': this.percent
                };
            } else if (this.commissionType === 'periodic') {
                data = {
                    'from': this.dateFrom,
                    'to': this.dateTo
                };
            }
            if (!data) {
                PNotify.error('Не указан способ оплаты.');
                this.loading = false;
                return;
            }

            if (!this.self && this.type !== Vue.GetpolisConstants.AGENT_TYPES.AGENT) {
                data.agents = this.selectedAgents;
            }

            axios.post('balance/pay', data).then(response => {
                if (response.data.status === 'ok') {
                    PNotify.success('Оплата создана.');
                    this.$emit('paymentCreated');
                } else {
                    if (response.data.message) {
                        PNotify.error(response.data.message);
                    } else {
                        PNotify.error('Возникла ошибка при создании оплаты.');
                    }
                }
            }).catch(error => {
                console.log(error);
                PNotify.error('Возникла ошибка при создании оплаты.');
            }).finally(() => {this.loading = false;})
        },
        goToFirstError() {
            this.$vuetify.goTo('.error--text', {
                duration: 600,
                offset: 150,
                easing: 'easeInCubic',
            });
        },
        toggleAgents() {
            this.$nextTick(() => {
                if (this.selectedAllAgents) {
                    this.selectedAgents = [];
                } else {
                    this.selectedAgents = this.agents.map(a => a.id);
                }
            });
        },
        togglePhysicalAgents() {
            this.$nextTick(() => {
                if (this.selectedAllPhysicalAgents) {
                    this.selectedAgents = [];
                } else {
                    if (this.selectedAgents.length === 0) {
                        this.selectedAgents = this.physicalAgentsArray;
                    } else {
                        this.selectedAgents = [];
                    }
                }
            });
        },
        log(data) {
            data.tile.props.value = true;
            console.log(data);
        }
    }
}
</script>

<style scoped>
.submit-button {
    color: #ffffff !important;
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 18px !important;
    text-transform: none !important;
    box-shadow: none !important;

    height: 56px;
    background-color: #00ba57 !important;;
    text-align: center;
    vertical-align: middle;
    padding: 0 !important;
    margin: 0 5px;

    border-width: 1px;
    border-radius: 100px;
    border-color: transparent;
    border-style: solid;
}

.width-100p {
    width: 100%;
}

.submit-button >>> .v-btn__content {
    white-space: pre-wrap;
    padding: 0 30px;
    line-height: 1.1;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/elements/PayCommission.vue